module.exports = __webpack_public_path__ + "static/img/bottom_bg_guarantee.e92f71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom_bg_guarantee.png
// module id = 2yOI
// module chunks = 1